
import React, { useEffect, useState } from 'react';
import { DynamicSelect } from '../components/_DynamicSelect';


type Props = {
    messageId: number[];
    mailFolders: any[];
    moveToFolder: Function;
    closePopup: Function
};
const MoveToFolderPopup = (props: Props) => {
    const [selectedFolder, setSelectedFolder] = useState<string>('');
    const [inputValue, setInputValue] = useState<string>('');
    const [folders, setFolders] = useState<any[]>([]);

    useEffect (()=>{
        console.log('MoveToFolderPopup mailFolders', props.mailFolders);
        const folders: any[] = [{
            name: '',
            label: '',
            type: 0,
            new: 0
        }];
        const mFolders: any[] = [];
        props.mailFolders.forEach((f: any)=>{
            const folder = {
                name: f.name,
                label: f.name,
                type: f.type,
                new: f.new
            };
            mFolders.push(folder);
            if (f.folders.length > 0) {
                f.folders.forEach ((s: any) => {
                    const folderLabel = f.name + ' > ' + s.name;
                    const folder = {
                        name: s.name,
                        label: folderLabel,
                        type: s.type,
                        new: s.new
                    };
                    mFolders.push(folder);
                })
            }
        });
        const mailFolders: any[] = [...folders, ...mFolders];
        console.log(mailFolders);
        setFolders(mailFolders);
    },[]);

    const closePopup = () => {
        props.closePopup();
    }

    const onSelectFolder = (e:any) => {
        const searchValue = e.target.value;
        setInputValue(searchValue)
        const selectedFolder = folders.find((f: any) => f.label == searchValue);
        if (selectedFolder) {
            setSelectedFolder(selectedFolder.name);
        } else {
            setSelectedFolder('');
        }
    }

    const moveToFolder = () => {
        props.moveToFolder(props.messageId, selectedFolder);
        // closePopup();
    }



    return (
    <div className="popup-wrapper">
        <section className="popup-window one-input move-to-folder rtl">
        <div className="close-icon pointer" onClick={(e:any)=>closePopup()}>
            <div className="popup-title"></div>
        </div>
        <div className="popup-content">
            <div className="popup-header">
                העבר לתקיה
            </div>
            <div className="popup-body">
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                נא לבחור תיקיה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="folder_list"
                                    onChange={onSelectFolder}
                                    value={inputValue} 
                                />
                                <datalist id="folder_list">
                                    {folders.map((o:any, i)=><option key={i} value={o.label}>{o.label}</option>)}
                                </datalist>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="popup-footer">
                <button className="button blue" onClick={(e:any)=>moveToFolder()} disabled={selectedFolder == ''}>
                    אישור
                </button>
            </div>
        </div>
        </section>
    </div>
    )
}

export default MoveToFolderPopup;